import { Input } from 'antd'
import React from 'react'

const OtpInput = ({ length, onChange: onOtpChange }) => {

    const handleKeyDown = (e) => {
        const isNumberKey = /[0-9]/.test(e.key);
        const isControlKey = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(e.key);
        const isClipboardAction = (e.ctrlKey || e.metaKey) && ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase());
    
        if (!isNumberKey && !isControlKey && !isClipboardAction) {
            e.preventDefault(); // Prevent default behavior if the input is not allowed
        }
    };

    const handleChange = (otp) => {
        if(otp && otp.length == length) onOtpChange(otp)
    }
  return (
    <div>
        <Input.OTP length={length} name='' onKeyDown={handleKeyDown} onChange={handleChange}/>
    </div>
  )
}

export default OtpInput